module.exports = __webpack_public_path__ + "static/media/cross-gray.39260d98.svg";